export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";